module.exports = __webpack_public_path__ + "static/media/YF86_03.61d00e7f.jpg";